import axiosInstance from './axiosConfig';

export const getTransfersApi = (params) => axiosInstance.get('/transfers', { params });

export const createTransferApi = (payload) => axiosInstance.post('/transfers', payload);

export const getPlayerTransfersApi = (playerId) =>
  axiosInstance.get(`/transfers/player/${playerId}`);

export const deleteTransferApi = (id) => axiosInstance.delete(`/transfers/${id}`);